// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"5c676c37","316":"93174bd1","428":"1dc8248c","453":"7c5847ee","455":"4f118f8f","591":"5d51e9cd"}[chunkId] + ".chunk.js";
};